module.exports = __webpack_public_path__ + "static/img/1039.de6728b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1039.jpg
// module id = 221
// module chunks = 0